import React from "react"

import { Label } from "../../components/shared/Inputs"
import PlacesAutocomplete from "../../components/shared/PlacesAutocomplete"
import { pickCityFromGoogleAddressComponents } from "../../utils/googlePlacesAddress"
import { stripUSAFromString } from "../../utils/utils"

const LocationPlacesSelect = ({
  label,
  location,
  setLocation,
  placeholder = "Start typing the street address",
  types = [],
  validationError
}) => {
  const id = "location-select-" + label.toLowerCase().replace(" ", "-")

  const clearAddressFields = (location) => ({
    ...location,
    address: null,
    secondaryAddress: null,
    neighborhood: null,
    city: null,
    cityGeocoded: null,
    stateProvince: null,
    stateAbbreviation: null,
    zip: null,
    country: null,
    countryCode: null,
    latitude: null,
    longitude: null,
    placeId: null,
    fullStreetAddress: null
  })

  const onPlaceSelected = (place) => {
    if (!place?.address_components?.length || !place?.geometry?.location) return

    setLocation((location) => {
      const newLocation = clearAddressFields(location)

      let streetNumber = null
      let route = null

      place.address_components.forEach((address) => {
        if (address.types.includes("street_number")) {
          streetNumber = address.long_name
        } else if (address.types.includes("route")) {
          route = address.long_name
        } else if (address.types.includes("neighborhood")) {
          newLocation.neighborhood = address.long_name
        } else if (address.types.includes("administrative_area_level_1")) {
          newLocation.stateProvince = address.long_name
          newLocation.stateAbbreviation = address.short_name
        } else if (address.types.includes("country")) {
          newLocation.country = address.long_name
          newLocation.countryCode = address.short_name
        } else if (address.types.includes("postal_code")) {
          newLocation.zip = address.long_name
        }
      })

      const cityPicked = pickCityFromGoogleAddressComponents(place.address_components)
      if (cityPicked) {
        newLocation.cityGeocoded = cityPicked
        newLocation.city = cityPicked
      }

      newLocation.address = [streetNumber, route].filter(Boolean).join(" ") || null
      newLocation.latitude = place.geometry.location.lat()
      newLocation.longitude = place.geometry.location.lng()
      newLocation.fullStreetAddress = place.formatted_address
      newLocation.placeId = place.place_id

      return newLocation
    })
  }

  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <PlacesAutocomplete
        apiKey={process.env.GOOGLE_MAPS_API_KEY}
        types={types}
        id={id}
        onPlaceSelected={onPlaceSelected}
        onChange={(e) => {
          const typedValue = e?.target?.value
          setLocation((location) => ({
            ...clearAddressFields(location),
            // Keep what the user typed visible, but require a suggestion selection
            // (fullStreetAddress remains null so LocationFlyout validation blocks Save)
            address: typedValue || null
          }))
        }}
        defaultValue={stripUSAFromString(location?.fullStreetAddress || location?.address || "")}
        placeholder={placeholder}
        validationError={validationError}
      />
    </div>
  )
}

export default LocationPlacesSelect
